import type { IShapeOfField } from "@/utils/zod";
import { z } from "@/utils/zod";
import type { IPhoneNumber } from "@/interfaces";
import { EmptyPhoneNumber } from "@constants";

export interface IEnterPhoneNumberFormSchema {
  phoneNumber: IPhoneNumber;
}

export const enterPhoneNumberInitialValues: IEnterPhoneNumberFormSchema = {
  phoneNumber: EmptyPhoneNumber,
};

export const enterPhoneNumberValidationSchema = z.object<
  IShapeOfField<IEnterPhoneNumberFormSchema>
>({
  phoneNumber: z.phone(),
});
